var _style, _path, _path2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightPosArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18903",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 394.5 511",
    style: {
      enableBackground: "new 0 0 394.5 511"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{opacity:2.000000e-02;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{fill:#FFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -632.7148,
    y1: 795.4775,
    x2: -633.3608,
    y2: 795.4775,
    gradientTransform: "matrix(-395 0 0 -511 -249783 406744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "var(--entity-0-color)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "var(--entity-0-color)"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.5,255.4l-140,255.1h254l140-255.1L253.5-0.5h-254L139.5,255.4z M207.5,250.3c0-2.6,2.1-4.7,4.7-4.7h64.1 v-10.9c0-1.8,1.1-3.5,2.7-4.3c1.7-0.7,3.7-0.4,5.1,0.8l21.9,20.3c1.9,1.7,2.2,4.6,0.5,6.5c-0.1,0.2-0.3,0.3-0.5,0.5l-21.9,20.3 c-1.4,1.2-3.4,1.5-5.1,0.8c-1.7-0.8-2.7-2.5-2.7-4.3v-10.9h-64.1c-2.6,0-4.7-2.1-4.7-4.7V250.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.5,255.4l-140,255.1h254l140-255.1L253.5-0.5h-254L139.5,255.4z M207.5,250.3c0-2.6,2.1-4.7,4.7-4.7h64.1 v-10.9c0-1.8,1.1-3.5,2.7-4.3c1.7-0.7,3.7-0.4,5.1,0.8l21.9,20.3c1.9,1.7,2.2,4.6,0.5,6.5c-0.1,0.2-0.3,0.3-0.5,0.5l-21.9,20.3 c-1.4,1.2-3.4,1.5-5.1,0.8c-1.7-0.8-2.7-2.5-2.7-4.3v-10.9h-64.1c-2.6,0-4.7-2.1-4.7-4.7V250.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "253.5,-0.5 254.5,-0.5 394.5,254.8 254.5,510.5 253.5,510.5 393.5,255.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPosArrow);
export default __webpack_public_path__ + "static/media/right-pos-arrow.80bfe2488ed504419b1f3fab1e52d95f.svg";
export { ForwardRef as ReactComponent };